import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTablesDisplayGridRowDataFragmentGql } from './VirtualConnectionTablesDisplayGridRowDataFragmentGql';

export const LensUpstreamVirtualConnectionTablesQueryGql: DocumentNode = gql`
query LensUpstreamVirtualConnectionTablesQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!)
  {
  lenses(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionTablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionTablesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${VirtualConnectionTablesDisplayGridRowDataFragmentGql}
`;
